import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KeycloakSessionService } from '../services/auth/keycloak-session.service';
import { Store } from '@ngrx/store';
import { selectAuth } from '@app/features/auth/state/auth.selectors';

export const authGuard: CanActivateFn = async (_, state) => {
  const session = inject(KeycloakSessionService);
  const router = inject(Router);
  const auth = inject(Store).selectSignal(selectAuth)();
  if (session.authenticated && auth.currentUser) return true;
  if (auth.error) return router.parseUrl('/auth');
  try {
    await session.login(state.url);
  } catch {
    return router.parseUrl('/auth');
  }
  return false;
};
